export default {"src":"/_next/static/media/first-place-icon.b7070ff9.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};